import gql from 'graphql-tag'
import { graphql, ChildDataProps } from 'react-apollo'

export type InputProps = {}

export type Variables = {}

export type Response = {}

type ChildProps = ChildDataProps<InputProps, Response, Variables>

const RESET_GLOBAL_PRODUCT_PRICE_MUTATION = gql`
  mutation resetAllGlobalCustomProductPrice {
    resetAllGlobalCustomProductPrice
  }
`

const withResetGlobalProductPriceMutation = graphql<InputProps, Response, Variables, ChildProps>(
  RESET_GLOBAL_PRODUCT_PRICE_MUTATION,
  {
    name: 'resetGlobalProductPriceMutation',
  },
)

export default withResetGlobalProductPriceMutation
